import { render } from "./IconPardon.vue?vue&type=template&id=6eacd87c"
import script from "./IconPardon.vue?vue&type=script&lang=js"
export * from "./IconPardon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__